import FormattedMessage from 'I18n/components/FormattedMessage';
import { Text } from 'foundations-components/components/Text';
import { Link } from 'foundations-components/transitional/components/Link';
import MainSection from 'marketplace-ui-common/layout/components/MainSection';
import MainSectionInner from 'marketplace-ui-common/layout/components/MainSectionInner';
import { Fragment } from 'react';
import StorefrontExplainer from './StorefrontExplainer';
import StorefrontPartnerTiers from './StorefrontPartnerTiers';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StorefrontFooter = () => {
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx(StorefrontExplainer, {}), /*#__PURE__*/_jsx(MainSection, {
      children: /*#__PURE__*/_jsx(MainSectionInner, {
        children: /*#__PURE__*/_jsx(StorefrontPartnerTiers, {})
      })
    }), /*#__PURE__*/_jsx(MainSection, {
      children: /*#__PURE__*/_jsx(MainSectionInner, {
        divider: true,
        children: /*#__PURE__*/_jsx(Text, {
          paddingBlockStart: "600",
          textAlign: "center",
          children: /*#__PURE__*/_jsx(Link, {
            external: true,
            href: "https://legal.hubspot.com/directory-tou",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "ecosystem-marketplace-solutions-ui.storefront.termsOfUseLinkText"
            })
          })
        })
      })
    })]
  });
};
export default StorefrontFooter;